import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { UserActivity } from '../../../models/user/UserActivity';
import { UserActivityResponse } from '../../../../interfaces/response/UserResponses';

/**
 * An adapter converts user activity HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class UserActivityAdapter implements Adapter<UserActivity> {

  /**
   * Converts user activity HTTP response to {@link UserActivity}.
   * @param item user activity HTTP response.
   */
  adapt(item: UserActivityResponse): UserActivity {
    return new UserActivity(
      item.date,
      item.emailAddress,
    );
  }
}
